(() => {
  const drawer = document.querySelector('[data-cart-drawer]');
  const backdrop = document.querySelector('.nl-cart-backdrop');
  const toast = document.querySelector('[data-toast]');

  const escapeHtml = (value) => {
    const node = document.createElement('div');
    node.textContent = value == null ? '' : String(value);
    return node.innerHTML;
  };

  const money = (cents, currency = 'USD') => {
    try { return new Intl.NumberFormat(undefined, { style: 'currency', currency }).format(cents / 100); }
    catch (_) { return `$${(cents / 100).toFixed(2)}`; }
  };

  const setDrawer = (open) => {
    if (!drawer) return;
    drawer.classList.toggle('open', open);
    drawer.setAttribute('aria-hidden', String(!open));
    document.body.classList.toggle('cart-open', open);
    if (backdrop) backdrop.hidden = !open;
  };

  const announce = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('show');
    window.setTimeout(() => toast.classList.remove('show'), 2400);
  };

  const renderCart = async () => {
    const response = await fetch('/cart.js', { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Cart could not be loaded');
    const cart = await response.json();
    document.querySelectorAll('[data-cart-count]').forEach((node) => { node.textContent = cart.item_count; });
    const body = document.querySelector('[data-cart-body]');
    if (!body) return cart;
    if (!cart.item_count) {
      body.innerHTML = '<div class="nl-empty-cart"><p>Your bag is waiting.</p><button type="button" data-cart-close>Continue shopping ↗</button></div>';
      return cart;
    }
    body.innerHTML = cart.items.map((item) => {
      const image = item.image ? `<img src="${escapeHtml(item.image)}&width=180" alt="${escapeHtml(item.product_title)}" width="92" height="115">` : '';
      return `<div class="nl-cart-item">${image}<p>${escapeHtml(item.product_title)}<br><span>Qty ${item.quantity} / ${money(item.final_line_price, cart.currency)}</span></p></div>`;
    }).join('') + '<a class="nl-checkout" href="/cart">View bag <span>↗</span></a>';
    return cart;
  };

  document.addEventListener('click', (event) => {
    if (event.target.closest('[data-cart-open]')) setDrawer(true);
    if (event.target.closest('[data-cart-close]')) setDrawer(false);
  });

  document.addEventListener('keydown', (event) => {
    if (event.key === 'Escape') setDrawer(false);
  });

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('.nl-quick-add, .nl-product-form');
    if (!form) return;
    event.preventDefault();
    const button = form.querySelector('button[type="submit"]');
    if (button) button.disabled = true;
    try {
      const response = await fetch('/cart/add.js', { method: 'POST', body: new FormData(form), headers: { Accept: 'application/json' } });
      if (!response.ok) throw new Error('This item could not be added');
      const item = await response.json();
      await renderCart();
      announce(`${item.product_title || 'Item'} added to your bag`);
      setDrawer(true);
    } catch (error) {
      announce(error.message || 'Something went wrong');
    } finally {
      if (button) button.disabled = false;
    }
  });
})();
